/**
 * Lógica pura de detecção de conquistas novas.
 *
 * Compara o que o back devolve em `GET /users/me/badges` com o seen-set
 * local e decide o que merece um banner: conquistas ainda não vistas,
 * ganhas recentemente, e que não vieram de backfill (lote retroativo).
 */

import type { UserBadge } from '@/services/badges.service'
import { isRecent, trophyUid } from './trophy-storage'

/**
 * Troféus que devem virar banner: não vistos + recentes + não-backfill.
 * Ordenados por `earnedAt` asc — a fila exibe na ordem cronológica.
 */
export function diffNewTrophies(fetched: UserBadge[], seen: Set<string>, now: number): UserBadge[] {
  return fetched
    .filter((ub) => ub.source !== 'backfill')
    .filter((ub) => !seen.has(trophyUid(ub)))
    .filter((ub) => isRecent(ub.earnedAt, now))
    .sort((a, b) => Date.parse(a.earnedAt) - Date.parse(b.earnedAt))
}

/**
 * Novo seen-set: une o atual com TODOS os troféus buscados — inclusive
 * antigos e de backfill. Assim conquistas que não geraram banner (velhas
 * ou retroativas) nunca voltam a ser candidatas numa próxima busca.
 */
export function computeNextSeen(fetched: UserBadge[], seen: Set<string>): Set<string> {
  const next = new Set(seen)
  for (const ub of fetched) {
    next.add(trophyUid(ub))
  }
  return next
}
